import Typography from "components/basic/typography";

/** A paragraph of legal page prose. */
const LegalParagraph: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Typography variant="body1" sx={{ marginBottom: 2 }}>
    {children}
  </Typography>
);

export default LegalParagraph;
